import config from '@/config'
import { store } from '@/store/store'
import axios from 'axios'

const instance = () =>
  axios.create({
    baseURL: `${config.serverUrl}api/tremendous`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })

const tremendousApi = {
  getCustomerList: (request) => {
    const { config, pageId } = request
    return instance().get(`/${pageId}/member`, config)
  },
  patchUpdateMember: (request) => {
    const { data, pageId, memberId } = request
    return instance().patch(`/${pageId}/member/${memberId}`, data)
  },
  getPledgeWaterLog: (request) => {
    const { pageId, memberId, config } = request
    return instance().get(`/${pageId}/pledge-water-log/${memberId}`, {
      params: config
    })
  },
  getBranchList: () => {
    return instance().get(`/get_branch_list`)
  },
  putOrderSummaryShippingDate: (request) => {
    const { data } = request
    return instance().put(`/ordersummary/shipping-date`, data)
  },
  getEditHistoryLog: (request) => {
    const { pageId, config } = request
    return instance().get(`/${pageId}/edit-history-log`, config)
  },
  getShippingAddress: (request) => {
    const { params } = request
    return instance().get(`/cms/shipping-address`, { params })
  },
  putUpdateShippingAddress: (request) => {
    const { data } = request
    return instance().put(`/cms/shipping-address`, data)
  }
}
export default tremendousApi



// WEBPACK FOOTER //
// ./src/api/tremendous.js